import React, { useEffect, useState } from "react";
import Card from "../Common/Card";
import toast from "react-hot-toast";
import ajaxCounts from "../../util/remote/ajaxCounts";
export default function StationsCardsComponent() {
  const company_id = Number(localStorage.getItem("FuelFy@company_id"));
  const station_id = Number(localStorage.getItem("FuelFy@station_id"));
  const formatNumber = (num) => {
    if (!num) return "0";
    return Number(num).toLocaleString("en-US");
  };
  const formatCurrency = (num) => {
    if (!num) return "0 UGX";
    return Number(num).toLocaleString("en-US") + " UGX";
  };
  const [tanks, setTanks] = useState(0);
  const [pumps, setPumps] = useState(0);
  const [clients, setClients] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [totalLitres, setTotalLitres] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const loadTanks = async () => {
    const res = await ajaxCounts.count_tanks_station({ station_id });
    if (res?.status === "OK") setTanks(res.details || 0);
  };
  const loadPumps = async () => {
    const res = await ajaxCounts.count_pumps_station({ station_id });
    if (res?.status === "OK") setPumps(res.details || 0);
  };
  const loadClients = async () => {
    const res = await ajaxCounts.count_users_station({ station_id });
    if (res?.status === "OK") setClients(res.details || 0);
  };
  const loadSalesTransactions = async () => {
    const res = await ajaxCounts.station_month_sales_sum_ups({ station_id });
    if (res?.status === "OK") {
      setTotalSales(res.details?.total_transactions || 0);
    }
  };
  const loadSalesSum = async () => {
    const res = await ajaxCounts.station_month_sales_sum_ups({ station_id });
    if (res?.status === "OK") {
      setTotalLitres(Number(res.details?.total_litres || 0));
      setTotalAmount(Number(res.details?.total_amount || 0));
    }
  };
  const loadAll = async () => {
    setLoading(true);
    loadTanks();
    loadPumps();
    loadClients();
    loadSalesTransactions();
    loadSalesSum();
    setLoading(false);
  };
  useEffect(() => {
    loadAll();
  }, [station_id]);
  return (
    <div>
      <div className="row row-sm">
        <Card
          value={formatNumber(tanks)}
          color="blue"
          icon="fa-brands fa-servicestack"
          title="Number Of Tanks"
        />
        <Card
          value={formatNumber(pumps)}
          color="blue"
          icon="fa-solid fa-gas-pump"
          title="Number Of Pumps"
        />
        <Card
          value={formatNumber(totalLitres)}
          color="blue"
          icon="fa-solid fa-droplet"
          title="Fuel Volume Sold (Litres)"
        />
        <Card
          value={formatNumber(clients)}
          color="blue"
          icon="fa-solid fa-users"
          title="Number Of Users"
        />
        <Card
          value={formatNumber(totalSales)}
          color="blue"
          icon="fa-solid fa-cart-shopping"
          title="Number Of Sales"
          details1="Total Transactions"
        />
        <Card
          value={formatCurrency(totalAmount)}
          color="blue"
          icon="fa-solid fa-coins"
          title="Total Revenue"
        />
      </div>
    </div>
  );
}
